module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.482fe0a9.woff";